<div class="grid grid-cols-1">
  <div class="flex justify-center from-To-Display">
    <nz-tag [nzColor]="'purple'" class="whitespace-normal"> {{ this.transport.displayNameFrom }}</nz-tag>
  </div>
  <span class="mb-4 mt-4 flex justify-center text-2xl" nz-icon nzType="arrow-down" nzTheme="outline"></span>
  <div class="flex justify-center from-To-Display">
    <nz-tag [nzColor]="'purple'" class="whitespace-normal"> {{ this.transport.displayNameTo }}</nz-tag>
  </div>
</div>
<div class=" mt-5 grid grid-cols-3 gap-y-4">
  <div>
    <h5>{{ 'itineraries.viewContentModal.transport.selectedDate' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{ !this.itinerary?.tour?.isDatesOptional ? (this.transport.selectedDate | date: 'dd/MM/yyyy') : this.getDayWithNum(this.transport.selectedDate) }}
      </nz-tag>
    </div>
  </div>
  <div>
    <h5>{{ 'itineraries.viewContentModal.transport.mileage' | transloco }}</h5>
    <div>
      <nz-tag
        [nzColor]="'purple'">
        {{
          (this.transport.mileage | number: '1.2-2') + " " + (this.transport.mileageUnit | titlecase)

        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle ==='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.costPerMileage' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          (this.transport.costPerMileage  | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle ==='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.driverBata' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          (this.transport.driverBata  | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle ==='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.costPerPerson' | transloco }}</h5>
    <div>
      <nz-tag
        [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          ( this.amountPerPerson | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle !=='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.costPerAdult' | transloco }}</h5>
    <div>
      <nz-tag
        [nzColor]="'purple'">
        {{
        (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
        (this.transport.perAdult | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle !=='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.costPerChild' | transloco }}</h5>
    <div>
      <nz-tag
        [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          (this.transport.perChild | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div *ngIf="this.transport.typeOfVehicle !=='land'">
    <h5>{{ 'itineraries.viewContentModal.transport.costPerInfant' | transloco }}</h5>
    <div>
      <nz-tag
        [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          (this.transport.perInfant  | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div>
    <h5>{{ 'itineraries.viewContentModal.transport.modeOfTravel' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{ this.transport.typeOfVehicle |titlecase }}
      </nz-tag>
    </div>
  </div>
  <div>
    <h5>{{ 'itineraries.viewContentModal.transport.totalCost' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ?  currency : secondaryCurrency ) + ' ' +
          (this.transport.totalCost | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
  <div>
    <h5>{{ 'itineraries.viewContentModal.transport.travelTime' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">{{ getTravelTimeLabel() }}</nz-tag>
    </div>
  </div>
</div>
<div class="mt-5">
  <h5>{{ 'itineraries.viewContentModal.transport.pax' | transloco }}</h5>
  <div class="flex">
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.adults }} {{ 'itineraries.viewContentModal.common.adults' | transloco }}
    </nz-tag
    >
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.children }} {{ 'itineraries.viewContentModal.common.children' | transloco }}
    </nz-tag
    >
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.infants }} {{ 'itineraries.viewContentModal.common.infants' | transloco }}
    </nz-tag
    >
  </div>
</div>
<div class="mt-5" *ngIf="this.transport?.transVehicleConfig">
  <h5>{{ 'itineraries.viewContentModal.transport.vehicleSelection' | transloco }}</h5>
  <div class="mt-2 space-y-4">
    <nz-tag class="whitespace-normal break-all" [nzColor]="'purple'"> {{ this.transport.transVehicleConfig }}</nz-tag>
    <div class="flex items-center">
      <img *ngIf="this.transport.vehicleImage"
        [src]="this.transport.vehicleImage"
        alt="Vehicle Image"
        class=" rounded-lg w-64 object-fit">
      <img *ngIf="!this.transport.vehicleImage"
        src="assets/img/placeholder-image.png"
        alt="Vehicle Image" class="w-64 rounded-lg object-fit">
    </div>
  </div>
</div>
<nz-divider></nz-divider>
<div>
  <h5>{{ 'itineraries.viewContentModal.common.notes' | transloco }}</h5>
  <div class="grid grid-cols-1">
    <div>
      <nz-tag class="whitespace-normal break-all" [nzColor]="'purple'"> {{ this.transport.notes || getEmptyValue() }}</nz-tag>
    </div>
  </div>
</div>
